import { customAxios, customPatchAxios } from "./customAxios";

/**
 * 설비대분류 전체 목록
 * @returns 
 */
export const getEquipmentCategoriesAll = async()=>{
  const res = await customAxios.get('/api/equipmentCategories');
  if (res.data) {
     return res.data;
  }
  return null;
}

/**
 * 설비대분류 상세
 * @param {*} id 
 * @returns 
 */
export const getEquipmentCategoriesById = async(id)=>{
  const res = await customAxios.get('/api/equipmentCategories/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 설비분류,설비구성부 목록(parent.id)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentCategoriesByQuery = async(query)=>{
 const res = await customAxios.get('/api/equipmentCategories', {params : query});
 //console.log(res);
 if (res.data) {
    return res.data;
 }
 return null;
}

/**
 * 설비대분류, 설비분류, 설비구성부 등록
 * @param {*} body 
 */
export const postEquipmentCategories = async(body)=>{
 //console.log(body);
 await customAxios.post('/api/equipmentCategories',body);
}

/**
 * 설비대분류 수정, 설비분류 수정, 설비구성부 수정, 구성부 위치 등록/수정/삭제
 * @param {*} body 
 */
export const patchEquipmentCategories = async(body)=>{
 //console.log(body);
 await customPatchAxios.patch('/api/equipmentCategories/'+body.id, body);
}

/**
 * 설비대분류, 설비분류, 설비구성부 삭제
 * @param {*} param 
 */
export const deleteEquipmentCategories = async(param)=>{
 //console.log(param);
 await customAxios.delete('/api/equipmentCategories/'+param);
}

/**
 * 설비자재 전체 목록
 * @returns 
 */
export const getMasterEquipmentPartsAll = async()=>{
  const res = await customAxios.get('/api/masterEquipmentParts');
  if (res.data._embedded) {
     return Object.values(res.data._embedded);
  }
  return null;
}

/**
 * 설비자재 목록(equipmentCtgr.id)
 * @param {*} query 
 * @returns 
 */
export const getMasterEquipmentPartsByQuery = async(query)=>{
  const res = await customAxios.get('/api/masterEquipmentParts', {params : query});
  //console.log(res);
  if (res.data) {
     return res.data;
  }
  return null;
 }

/**
 * 설비자재 스펙 정보
 * @param {*} id 
 * @returns 
 */
export const getMasterEquipmentPartsById = async(id)=>{
  const res = await customAxios.get('/api/masterEquipmentParts/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 설비자재 등록
 * @param {*} body 
 */
export const postMasterEquipmentParts = async(body)=>{
 //console.log(body);
 await customAxios.post('/api/masterEquipmentParts',body);
}

/**
 * 설비자재 수정
 * @param {*} body 
 */
export const patchMasterEquipmentParts = async(body)=>{
 //console.log(body);
 await customPatchAxios.patch('/api/masterEquipmentParts/'+body.id, body);
}

/**
 * 설비자재 삭제
 * @param {*} param 
 */
export const deleteMasterEquipmentParts = async(param)=>{
 //console.log(param);
 await customAxios.delete('/api/masterEquipmentParts/'+param);
}

/**
 * 설비자재 동종평균값 가져오기
 * @param {*} query 
 * @returns 
 */
export const getMasterEquipmentPartHistoriesByQuery = async(query)=>{
  const res = await customAxios.get('/api/masterEquipmentPartHistories', {params : query});
  // console.log(res);
  if (res.data) {
     return res.data;
  }
  return null;
 }

/**
 * 스펙 등록
 * @param {*} body 
 */ 
export const addSpecMasterEquipmentParts = async(masterPartId, body)=>{
  //console.log(body);
  await customPatchAxios.post('/api/masterEquipmentParts/'+masterPartId+'/specKeys', body);
}


/**
 * 스펙 일괄수정
 * @param {*} body 
 */ 
export const addAllSpecMasterEquipmentParts = async(masterPartId, body)=>{
  //console.log(body);
  const res =  await customPatchAxios.patch('/api/masterEquipmentParts/'+masterPartId+'/specKeys', body);
  console.log(res);
}

/**
 * 스펙 수정
 * @param {*} body 
 */ 
export const updateSpecMasterEquipmentParts = async(masterPartId,body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/masterEquipmentParts/'+masterPartId+'/specKeys/'+body.id, body);
}

/**
 * 스펙 삭제
 * @param {*} body 
 */ 
export const deleteSpecMasterEquipmentParts = async(masterPartId, id)=>{
  //console.log(body);
  await customPatchAxios.delete('/api/masterEquipmentParts/'+masterPartId+'/specKeys/'+id);
}
